import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./system/store";
import App from "./container/routes/App";
import { BrowserRouter } from "react-router-dom";
import "./assets/scss/index.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "./assets/fonts/STCForward-Medium.otf";
import AppWrapper from "./container/routes/AppWrapper";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
        <App />
      <ToastContainer position="top-right" autoClose={3000} newestOnTop />

    </BrowserRouter>
  </Provider>
);
// Optional: for measuring performance
reportWebVitals();
